/**
 * Airport Model Picker - Enhanced select with Choices.js and JSON data
 */

document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit for all scripts to load
  setTimeout(initAirportPicker, 200);
});

function initAirportPicker() {
  const selects = document.querySelectorAll('[data-airport-model-select]:not([data-choices-initialized]):not([data-error-state])');
  
  if (selects.length === 0) {
    return;
  }

  // Check if Choices.js is available
  if (typeof Choices === 'undefined') {
    console.warn('Choices.js not available, falling back to regular select');
    return;
  }

  // Fetch the airport models JSON (prefer URL injected by Liquid)
  const jsonUrl = window.AIRPORT_MODELS_URL || (
    window.Shopify?.routes?.root
      ? window.Shopify.routes.root + 'assets/airport-models.json'
      : '/assets/airport-models.json'
  );

  fetch(jsonUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(models => {
      if (!Array.isArray(models) || models.length === 0) {
        throw new Error('Invalid or empty airport models data');
      }
      selects.forEach(select => {
        populateAndEnhanceSelect(select, models);
      });
    })
    .catch(error => {
      console.warn('Failed to load airport models:', error);
      // Show disabled select with error message
      selects.forEach(select => {
        showErrorState(select);
      });
    });
}

/**
 * Populates a select element with airport models and enhances it with Choices.js
 * @param {HTMLSelectElement} select - The select element to populate
 * @param {string[]} models - Array of airport model names
 */
function populateAndEnhanceSelect(select, models) {
  // Clear existing options except the first placeholder
  const placeholder = select.firstElementChild;
  select.innerHTML = '';
  
  // Re-add placeholder if it existed
  if (placeholder && placeholder.value === '') {
    select.appendChild(placeholder);
  } else {
    // Create default placeholder
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'Select airport...';
    select.appendChild(defaultOption);
  }

  // Add model options
  models.forEach(model => {
    const option = document.createElement('option');
    option.value = model;
    option.textContent = model;
    select.appendChild(option);
  });

  // Initialize Choices.js
  initializeChoicesForSelect(select);
}

/**
 * Shows error state for a select element when data loading fails
 * @param {HTMLSelectElement} select - The select element to show error for
 */
function showErrorState(select) {
  // Clear existing options
  select.innerHTML = '';
  
  // Add error option
  const errorOption = document.createElement('option');
  errorOption.value = '';
  errorOption.textContent = 'Unable to load airport models';
  errorOption.disabled = true;
  errorOption.selected = true;
  select.appendChild(errorOption);
  
  // Disable the select
  select.disabled = true;
  select.setAttribute('data-error-state', 'true');
  
  // Add visual indicator
  select.style.opacity = '0.6';
  select.style.cursor = 'not-allowed';
}

/**
 * Initializes Choices.js for a select element
 * @param {HTMLSelectElement} select - The select element to enhance
 */
function initializeChoicesForSelect(select) {
  if (select.getAttribute('data-choices-initialized')) {
    return;
  }

  try {
    // Enhanced Choices.js configuration per updated plan
    const choices = new Choices(select, {
      searchEnabled: true,
      allowHTML: false,
      removeItemButton: true,
      addItems: true,
      duplicateItemsAllowed: false,
      searchResultLimit: 6,
      noResultsText: (value) => `No matches. <a href="/pages/contact" target="_blank" rel="noopener">Contact Us</a> to submit a custom request!`,
      searchPlaceholderValue: 'Type to search airports...',
      itemSelectText: '',
      shouldSort: false,
      fuseOptions: {
        threshold: .3, // lower = stricter
        ignoreLocation: true,
        minMatchCharLength: 2  
      }      
    });

    select.setAttribute('data-choices-initialized', 'true');
    select._choicesInstance = choices;
    
  } catch (error) {
    console.warn('Failed to initialize Choices.js:', error);
  }
}